import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CatExecutionComponent } from './cat-execution/cat-execution.component';
import { SharedComponentsModule } from 'src/app/shared-components/shared-components.module';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { CatExecutionRoutingModule } from './cat-execution.routing.module';
import { CatExecutionUploadDocumentsComponent } from './cat-execution-upload-documents/cat-execution-upload-documents.component';
import { CatExecutionFormComponent } from './cat-execution-form/cat-execution-form.component';
import { OrderconfirmationComponent } from './orderconfirmation/orderconfirmation.component';


@NgModule({
  declarations: [
    CatExecutionComponent,
    CatExecutionFormComponent,
    CatExecutionUploadDocumentsComponent,
    OrderconfirmationComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SharedComponentsModule,
    CatExecutionRoutingModule,
  ]
})
export class CatExecutionModule { }
